export function getDataset(
  element: EventTarget & HTMLElement,
  name: string
): string {
  let value: string | undefined | null;
  if (element.dataset) {
    value = element.dataset[name];
  } else if (element.getAttribute) {
    value = element.getAttribute(`data-${getDashStringOnUpperChar(name)}`);
  }
  return value || '';
}

function getDashStringOnUpperChar(str: string) {
  const chars: string[] = [];
  for (const char of str) {
    const code = char.charCodeAt(0);
    // A ~ Z
    if (code >= 65 && code <= 90) {
      chars.push('-');
      chars.push(char.toLowerCase());
    } else {
      chars.push(char);
    }
  }
  return chars.join('');
}
